import Link from "next/link";

function ClockIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

const formatDate = (dateString) => {
  if (!dateString) return "Recently published";
  const parsed = new Date(dateString);
  if (Number.isNaN(parsed.getTime())) return dateString;

  return parsed.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const getReadingTime = (value) => {
  if (!value) return "5 min read";
  if (typeof value === "string") return value;
  return `${value} min read`;
};

export default function BlogCard({ blog = {} }) {
  const category = blog?.category?.title || "AI Insights";
  const title = blog?.title || "Untitled article";

  return (
    <Link
      href={blog?.slug ? `/blogs/${blog.slug}` : "/blogs"}
      className="group flex w-full max-w-[400px] no-underline transition-all duration-300"
    >
      <article className="flex h-full w-full flex-col overflow-hidden rounded-2xl border border-line bg-surface shadow-[0_12px_32px_-20px_rgba(15,28,26,0.2)] transition-all duration-300 hover:-translate-y-1 hover:border-[#5aada4]/55 hover:shadow-[0_20px_44px_-18px_rgba(28,140,128,0.22)]">
        <div className="relative aspect-[16/9] overflow-hidden">
          <img
            src={blog?.bg_image || "/nivalabs.png"}
            alt={title}
            width={400}
            height={225}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute bottom-3 left-3 rounded-md bg-surface/95 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-[#1c8c80]">
            {category}
          </span>
        </div>

        <div className="flex flex-1 flex-col gap-4 p-5">
          <h3 className="m-0 line-clamp-2 text-xl font-semibold leading-snug text-ink transition-colors group-hover:text-[#1c8c80]">
            {title}
          </h3>

          <div className="mt-auto flex items-center justify-between border-t border-line pt-4 text-xs text-ink-soft">
            <span>{formatDate(blog?.modified)}</span>
            <span className="inline-flex items-center gap-1">
              <ClockIcon />
              {getReadingTime(blog?.read_time)}
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
}
